import * as React from "react";
import type { SVGProps } from "react";
const SvgPopularVillage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#popular-village_svg__a)">
      <path d="M9 22H3a1 1 0 0 1-1-1V9a1 1 0 0 1 .4-.8l8-6a1 1 0 0 1 1.2 0l8 6a1 1 0 0 1 .4.8v3a1 1 0 0 1-2 0V9.5l-7-5.25L4 9.5V20h4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-1v5a1 1 0 0 1-1 1" />
      <path d="M17.5 22a1 1 0 0 1-.7-.29l-2.91-2.88a2.94 2.94 0 0 1 3.62-4.6 2.94 2.94 0 0 1 3.61 4.6l-2.87 2.85a1 1 0 0 1-.75.32m-2.21-4.6 2.21 2.19 2.21-2.19a.13.13 0 0 0 .06-.07.9.9 0 0 0 .19-.7.88.88 0 0 0-.37-.62.94.94 0 0 0-1.32.18 1 1 0 0 1-1.6 0L16.6 16a.943.943 0 1 0-1.31 1.36z" />
    </g>
    <defs>
      <clipPath id="popular-village_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPopularVillage;
